import React from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import PropTypes from 'prop-types'

import keyUpHandler from '../../utils/keyUpHandler'
import SubscribeDialogCTA from '../../App/SubscribeDialogCTA'
import getRoutePath from '../../utils/getRoutePath'

import './styles.css'

export const parseSubscriberAction = (action) => {
  if (typeof action === 'string' && /tutorials\/.*\/watch/.test(action)) {
    const routePath = getRoutePath(window.location.href)
    if (/\?.*=.*/.test(action)) return `${action}&referer=${routePath}`
    return `${action}?referer=${routePath}`
  }
  return action
}

function FeaturedElement({
  btn = {},
  categoryLinkTo = '',
  categoryName = '',
  description = '',
  isMobile = false,
  onClick = null,
  usedFreeTrial = false,
  titleAs: TitleTag = 'h1',
  ...props
}) {
  const withClick = onClick
  const hasBtn = !_.isEmpty(btn)
  const trailerBtn = (
    <button
      aria-labelledby="preview-label"
      onClick={() => onClick()}
      onKeyUp={(event) => keyUpHandler(event, onClick)}
      tabIndex="0"
      type="button"
    >
      <i className="icon-play" />
      <span id="preview-label" className="preview">
        Preview
      </span>
    </button>
  )

  return (
    <div className="FeaturedElement">
      <div
        className="photo"
        style={{ backgroundImage: `url('${props?.photo.original}')` }}
      >
        {withClick && <div className="overlay">{trailerBtn}</div>}
        {props.new && <div className="new-course-badge">new course</div>}
      </div>
      <div className="headline">
        {categoryLinkTo && (
          <Link to={categoryLinkTo} className="category">
            {categoryName}
          </Link>
        )}
        <div className="title-container">
          <TitleTag className="title">{props.title}</TitleTag>
          <div className="separator" />
          <h2 className="artist">{props.artist}</h2>
        </div>
        {hasBtn &&
          btn.text !== 'Subscribe to Watch' &&
          typeof btn.action !== 'function' && (
            <Link
              to={parseSubscriberAction(btn.action)}
              className={
                btn.class
                  ? btn.class
                  : 'read-on btn -thin -blue-2 no-margin'
              }
            >
              {btn.text}
            </Link>
          )}
        {hasBtn &&
          btn.text === 'Subscribe to Watch' &&
          typeof btn.action !== 'function' && (
            <SubscribeDialogCTA>
              <div className="subscribe-to-watch-btn">
                <span>{btn.text}</span>
              </div>
            </SubscribeDialogCTA>
          )}
        {!usedFreeTrial &&
          hasBtn &&
          btn.text === 'Subscribe to Watch' &&
          typeof btn.action !== 'function' && (
            <span className="add-to-cart-msg">Free 7-Day Trial</span>
          )}
        {hasBtn && typeof btn.action === 'function' && (
          <button
            className={
              btn.class
                ? btn.class
                : 'read-on btn -thin -blue-2 no-margin'
            }
            onClick={() => btn.action()}
            type="button"
          >
            {btn.text}
          </button>
        )}
        {props.extraHTML && <div className="extra-html">{props.extraHTML}</div>}
      </div>
    </div>
  )
}

export const FeaturedElementStructure = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  photo: PropTypes.objectOf(PropTypes.string).isRequired,
  onClick: PropTypes.func,
  btn: PropTypes.shape({
    text: PropTypes.string,
    action: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    class: PropTypes.string
  }),
  categoryName: PropTypes.string,
  categoryLinkTo: PropTypes.string,
  isMobile: PropTypes.bool,
  usedFreeTrial: PropTypes.bool
}

FeaturedElement.propTypes = {
  ...FeaturedElementStructure,
  titleAs: PropTypes.oneOf(['h1', 'h2', 'h3'])
}

export default FeaturedElement
